import { FaDownload, FaFileDownload, FaFileImport } from "react-icons/fa";
import { UploadOfficesApi } from "../../services/Api";
import React, { useState, useContext } from "react";
import AppContext from "../../AppContext";
import BtnSpinner from "../../components/BtnSpinner";

const UploadOffices = () => {
  const global = useContext(AppContext);
  const [file, setFile] = useState("");
  const [success_msg, setSuccess_msg] = useState("");
  const [is_loading, setIs_loading] = useState(false);
  const [is_deleting, setIs_deleting] = useState(false);
  const [succ_msg, setSucc_msg] = useState("");
  
  const uploadFile = (event) => {
    event.preventDefault();
    setIs_loading(true);
    const data = new FormData();
    data.append("country_offices", event.target.files[0]);
    UploadOfficesApi(data).then((res) => {
      setIs_loading(false);
      setSuccess_msg(res.data["message"]);
      setFile("");
    });
  };

  return (
    <div>
      <>
        <div style={{ margin: "auto", width: "98%" }}>
          {succ_msg}
          <p
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: "bold",
              fontSize: 25,
            }}
            id="msg"
          />

          {/* <form id="fileUpload_form"> */}
          <center>
            <div className="card" style={{ width: "60%", margin: "auto" }}>
              <br />
              <div className="row">
                <div className="col-md-12" style={{ textAlign: "center" }}>
                  <a
                    href="/excel_files/.xlsx"
                    className="btn btn-success"
                    download
                  >
                    <FaDownload style={{ color: "white" }} /> &nbsp; Download
                    Sample Excel File
                  </a>
                </div>
              </div>
              <div className="card-body">
                <center>
                  <img
                    src="/icons/excel.png"
                    style={{ height: 100, width: 100 }}
                  />
                </center>
                <div className="section-title">
                  <h2>Upload Office Information</h2>
                </div>
                <div className="form-group">
                  <div className="input-group mb-3">
                    <input
                      type="file"
                      style={{ height: "50" }}
                      className="form-control"
                      onChange={(e) => uploadFile(e)}
                      //accept=".xlsx, .xls, .csv"
                      name="file"
                      placeholder
                      aria-label
                      required
                    />
                    <div className="input-group-append">
                      {is_loading ? (
                        <BtnSpinner
                          is_loading={is_loading}
                          text={"Processing"}
                          color={"white"}
                          class={"btn btn-primary"}
                          size="5"
                        />
                      ) : (
                        <button type="button" className="btn btn-primary">
                          <FaFileImport style={{ color: "white" }} /> &nbsp;
                          Import
                        </button>
                      )}
                    </div>
                  </div>
                  <p
                    style={{
                      textAlign: "center",
                      color: "blue",
                      fontWeight: "bold",
                      fontSize: 25,
                    }}
                  >
                    <h1>{success_msg}</h1>
                  </p>
                </div>
              </div>
            </div>
          </center>
          {/* </form> */}
        </div>
        <br />
        <br />
      </>
    </div>
  );
};

export default UploadOffices;
